
const Common = {

    // BUTTON
    "add": "Gumawa",
    "submit": "I-save",
    "apply": "Ilapat",
    "clear": "I-clear",
    "cancel": "Kanselahin",
    "ok": "Ok",
    "save_next": "I-save at Susunod",
    "close": "Isara",

    // PAGE HEADER
    "filter": "Salain",

    // TOOLTIP
    "download": "I-download",
    "pdf": "PDF",
    "excel": "Excel",
    "edit": "I-edit",
    "delete": "Tanggalin",

    // TOAST
    "success_add": "Matagumpay na Nalikha",
    "success_update": "Matagumpay na Na-edit",
    "wrong": "May nangyaring mali",

    // SWEET ALERT
    "confirm_text": "Sigurado ka bang gusto mong tanggalin?",
    "delete_text": "Matagumpay na Natanggal",

    // TABLE HEADER
    "table_no": "BILANG",
    "table_action": "AKSYON",

    // PAGINATION
    "page_size": "Laki ng Pahina",
    "previous": "Nakaraan",
    "next": "Susunod",

}

export default Common;